import { reportingHistoryStarted, reportingHistorySucceeded, reportingHistoryFailure, propertyContactsStarted, propertyContactsSucceeded, propertyContactsFailure, permitActionabilityStarted, permitActionabilitySucceeded, permitActionabilityFailure } from './licenseViewSlice'
import first from 'lodash/first';
import get from 'lodash/get';

export const getReportingHistoryByApplicationNumberAsync = (applicationNumber) => {
    return async (dispatch, getState, api) => {
        dispatch(reportingHistoryStarted())
        try {
            const response = await api.getReportingHistoryByApplicationNumber(getState(), applicationNumber);
            if (response.status === 200) {
                dispatch(reportingHistorySucceeded(first(get(response?.data, 'licenses')) || null));
            } else {
                dispatch(
                    reportingHistoryFailure(
                        'Something went wrong while fetching reporting history.'
                    )
                );
            }
        } catch (error) {
            dispatch(reportingHistoryFailure('Something went wrong while fetching reporting history.'));
        }
    }
}

export const getPropertyContactsByApplicationNumberAsync = (applicationNumber) => {
    return async (dispatch, getState, api) => {
        dispatch(propertyContactsStarted());
        try {
            const response = await api.getPropertyContactsByApplicationNumber(getState(), applicationNumber);
            if (response.status === 200) {
                dispatch(propertyContactsSucceeded(response?.data));
            } else {
                dispatch(
                    propertyContactsFailure(
                        'Something went wrong while fetching property contacts.'
                    )
                );
            }
        } catch (error) {
            dispatch(propertyContactsFailure('Something went wrong while fetching property contacts.'));
        }
    }
}

export const getPermitActionabilityAsync = (applicationNumber) => {
    return async (dispatch, getState, api) => {
        dispatch(permitActionabilityStarted());
        try {
            const response = await api.getPermitActionability(getState(), applicationNumber);
            if (response.status === 200) {
                dispatch(permitActionabilitySucceeded(response?.data));
            } else {
                dispatch(
                    permitActionabilityFailure(
                        'Something went wrong while fetching permit actionability.'
                    )
                );
            }
        } catch (error) {
            dispatch(permitActionabilityFailure('Something went wrong while fetching permit actionability.'));
        }
    }
};